const smoothScroll = targetId =>
  document.getElementById(targetId)?.scrollIntoView({
    behavior: 'smooth',
    inline: 'nearest',
  });

export default smoothScroll;
